/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Detail from "./detail";
import Payment from "../payment/Payment";



import {
    convertTextToThaiQwerty,
    isNumeric,
    parseUrlParams,
    calculateFees,
    debounce,
    getTransactionSession,
    getRule_by_AreaId
} from './utils';
import {
    denormalizeDataForApi,
    calculateParkingFee,
    normalizeDataForForm
} from './billingUtils.js';
import moment from 'moment';

function Home() {
    const [licensePlate, setLicensePlate] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [convertedPlate, setConvertedPlate] = useState('');
    const [feeDetails, setFeeDetails] = useState(null);
    const [message, setMessage] = useState('');
    const [alldatas, setalldata] = useState(null);
    const [onPayment, setOnPayment] = useState(false);

    useEffect(() => {
        const alldata = parseUrlParams();
        if (alldata) {
            setalldata(alldata)
            processSessionCode(alldata)
        }
    }, []);

    const handleLicensePlateInput = useCallback(
        debounce((inputText) => {
            if (inputText) {
                processLicensePlate(inputText);
            }
        }, 500),
        []
    );

    async function calcMoney(
        entryAt,
        exitAt,
        ruleForm,
        is_estamp = false
    ) {
        if (!ruleForm || !!is_estamp) return { cash: 0, totalFee: 0 };
        const apiRule = denormalizeDataForApi(ruleForm);
        const totalFee = calculateParkingFee(moment(entryAt), moment(exitAt), apiRule);

        const fee = (totalFee)?.totalFee ?? totalFee;
        return { cash: Math.max(0, Number(fee || 0)), totalFee };
    }
    function humanDuration(entry, exit) {
        if (!entry || !exit) return "-";

        const diffMs = moment(exit).diff(moment(entry), 'milliseconds');
        if (diffMs <= 0) return "-";

        const totalSeconds = Math.floor(diffMs / 1000);
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const s = totalSeconds % 60;

        const ceilH = Math.ceil(totalSeconds / 3600);
        // `${h} ชั่วโมง ${m} นาที ${s} วินาที`
        // ให้ผลแบบแยกบรรทัด
        return {
            h: h,
            m: m,
            s: s,
            ceilText: ceilH,
        };
    }
    useEffect(() => {
        handleLicensePlateInput(licensePlate);
    }, [licensePlate, handleLicensePlateInput]);
    const processSessionCode = async (alldata) => {
        const response = await getTransactionSession({ session_code: alldata[1], limit: 10, order_by: "id", sort: "desc" });
        const session = response?.data?.[0]
        console.log(session);

        if (response?.total > 0 && !session?.exitAt) {
            const responseRule = await getRule_by_AreaId({ area_id: session?.area_id, person_type: session?.person_type, vehicle_type_id: session?.vehicle_type_id })
            const exitAt = session?.exitAt
                ? moment(session?.exitAt).format("YYYY-MM-DD HH:mm:ss")
                : moment().format("YYYY-MM-DD HH:mm:ss");
            const entryAt = moment(session.entryAt).format("YYYY-MM-DD HH:mm:ss");
            const formRule = responseRule ? normalizeDataForForm(responseRule) : null;
            const { h, m, s, ceilText } = humanDuration(entryAt, exitAt);

            const fees2 = await calcMoney(
                moment(entryAt).format("YYYY-MM-DD HH:mm:ss"),
                exitAt,
                formRule,
                session?.is_estamp === 1
            );
            const requirePayment = session?.cashier_payment?.reduce((prev, current) => {
                return prev.id > current.id ? prev : current;
            });

            setFeeDetails(fees2 ? {
                summ: fees2.cash,
                difftime_h_cal: fees2?.totalFee?.chargeDuration ? Math.ceil(fees2.totalFee?.chargeDuration) : 0,
                fee_h: fees2.totalFee?.chargeDuration ? Math.trunc(fees2.totalFee?.chargeDuration) : 0,
                fee_m: fees2.totalFee?.chargeDuration ? Math.trunc((fees2.totalFee?.chargeDuration - Math.trunc(fees2.totalFee?.chargeDuration)) * 60) : 0,
                difftime_h: h ? Math.trunc(h) : 0,
                difftime_m: m ? m : 0,
                datetime_in: entryAt,
                datetime_now: exitAt,
                starter_free_minute: formRule?.starter_free_minute || 0,
                paid: session?.cashier_payment?.reduce(
                    (accumulator, currentValue) =>
                        accumulator + (currentValue?.total_amount || 0),
                    0,
                ) || 0,
                requirePayment:
                    moment().diff(
                        moment(requirePayment?.createdAt)?.add(
                            formRule?.starter_free_after_payment * 60,
                            "second",
                        ),
                        "second",
                    ) > 0 ||
                    (fees2.cash > 0 && !session?.is_payment),
            } : null);
            setConvertedPlate(session?.entry_License || null);
            setData(session || null);

        } else {
            setMessage(response?.total > 0 ? "ขอบคุณที่ใช้บริการ" : "ไม่พบข้อมูล")
            setFeeDetails(null)
        }
        setShowDetails(true);
    }
    const processLicensePlate = async (plate) => {
        const response = await getTransactionSession({ entry_License: plate, limit: 1, order_by: "id", sort: "desc" });
        const session = response?.data?.[0]
        if (response?.total > 0 && !session?.exitAt) {
            const responseRule = await getRule_by_AreaId({ area_id: session?.area_id, person_type: session?.person_type, vehicle_type_id: session?.vehicle_type_id })
            // const fees = await calculateFees(session?.entryAt, moment(), responseRule);
            // setFeeDetails(fees || null);
            const exitAt = session?.exitAt
                ? moment(session?.exitAt).format("YYYY-MM-DD HH:mm:ss")
                : moment().format("YYYY-MM-DD HH:mm:ss");
            const entryAt = moment(session.entryAt).format("YYYY-MM-DD HH:mm:ss");
            const formRule = responseRule ? normalizeDataForForm(responseRule) : null;
            const { h, m, s, ceilText } = humanDuration(entryAt, exitAt);
            const fees2 = await calcMoney(
                moment(entryAt).format("YYYY-MM-DD HH:mm:ss"),
                exitAt,
                formRule,
                session?.is_estamp === 1
            );

            const requirePayment = session?.cashier_payment?.reduce((prev, current) => {
                return prev.id > current.id ? prev : current;
            });

            setFeeDetails(fees2 ? {
                summ: fees2.cash,
                difftime_h_cal: fees2?.totalFee?.chargeDuration ? Math.ceil(fees2.totalFee?.chargeDuration) : 0,
                fee_h: Math.trunc(fees2.totalFee?.chargeDuration),
                fee_m: Math.trunc((fees2.totalFee?.chargeDuration - Math.trunc(fees2.totalFee?.chargeDuration)) * 60),
                difftime_h: h ? Math.trunc(h) : 0,
                difftime_m: m ? m : 0,
                datetime_in: entryAt,
                datetime_now: exitAt,
                starter_free_minute: formRule?.starter_free_minute || 0,
                paid: session?.cashier_payment?.reduce(
                    (accumulator, currentValue) =>
                        accumulator + (currentValue?.total_amount || 0),
                    0,
                ),
                requirePayment:
                    moment().diff(
                        moment(requirePayment?.createdAt)?.add(
                            formRule?.starter_free_after_payment * 60,
                            "second",
                        ),
                        "second",
                    ) > 0 ||
                    (fees2.cash > 0 && !session?.is_payment),
            } : null);
            setData(session || null);

        } else {
            setMessage(response?.total > 0 ? "ขอบคุณที่ใช้บริการ" : "ไม่พบข้อมูล")
            setFeeDetails(null)
        }
        setConvertedPlate(plate || null);
        setShowDetails(true);

    }
    const handlePayment = () => {
        setOnPayment(true)
    }
    return (
        <div className="Home">
            <div className={`card shadows logo `} id="nodata">
                <img src="./assets/img/AccessLink_long.png" className="card-img-top p-3 pb-0" alt="Logo" />
                <div className={`card-body p-5 ${(alldatas || !!onPayment) ? 'd-none' : ''}`}>
                    <h4 className="card-title text-center">ค้นหาหมายเลขทะเบียน</h4>
                    <input
                        className="form-control form-control-lg text-center"
                        type="text"
                        placeholder="ตัวอย่าง: 1AB1234"
                        aria-label=".form-control-lg example"
                        value={licensePlate}
                        onChange={(e) => setLicensePlate(e.target.value)}
                    />
                </div>
                {!onPayment && (<Detail
                    licensePlate={licensePlate}
                    feeDetails={feeDetails}
                    convertedPlate={convertedPlate}
                    data={data}
                    message={message}
                    handlePayment={handlePayment} />
                )}
                {!!onPayment && (
                    <Payment transaction={data} fee={feeDetails} />
                )}


                {showDetails && !feeDetails && alldatas && (
                    <div id="free_charge" >
                        <h4 className="text-center  text-secondary py-5">{message}</h4>
                    </div>
                )}
            </div>

            <div style={{ width: '100%' }}>
                <p className="text-center">Version 1.0.0</p>
                <p className="text-center">© 2023 AccessLink Innovation Co., Ltd.</p>
            </div>
        </div>
    );
}

export default Home;
